import React, { useEffect, useReducer, useState } from "react";
/// Scroll
// import PerfectScrollbar from "react-perfect-scrollbar";
import Collapse from "react-bootstrap/Collapse";
/// Link
import { Link } from "react-router-dom";

import { sidebarMenu } from "../../Enums/Menu";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useSelector } from "react-redux";
import { Translate } from "../../Enums/Tranlate";

const reducer = (previousState, updatedState) => ({
	...previousState,
	...updatedState,
});

const initialState = {
	active: "",
	activeSubmenu: "",
};

const SideBar = (props) => {
	const [active, setActive] = useState("");
	const [state, setState] = useReducer(reducer, initialState);
	const lang = useSelector((state) => state.auth?.lang);
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	//For scroll
	const [hideOnScroll, setHideOnScroll] = useState(true);
	useScrollPosition(
		({ prevPos, currPos }) => {
			const isShow = currPos.y > prevPos.y;
			if (isShow !== hideOnScroll) setHideOnScroll(isShow);
		},
		[hideOnScroll]
	);

	const handleMenuActive = (status) => {
		setState({ active: status });
		if (
			state.active === status &&
			sidebarMenu
				.filter((res) => res?.title === status)[0]
				?.hasOwnProperty("content")
		) {
			setState({ active: "" });
		}
	};

	const handleSubmenuActive = (status) => {
		setState({ activeSubmenu: status });
		if (state.activeSubmenu === status) {
			setState({ activeSubmenu: "" });
		}
	};

	useEffect(() => {
		let page = window.location.pathname;
		let filter = sidebarMenu?.filter(
			(res) => `${res.to}` === page?.split("/")[1]
		);

		if (filter.length > 0) handleMenuActive(filter[0].title);
	}, [window.location.pathname]);

	/// Path
	let path = window.location.pathname;
	path = path.split("/");
	path = path[path.length - 1];

	return (
		<div className="deznav">
			<div className="deznav-scroll">
				<ul className="metismenu" id="menu">
					{sidebarMenu.map((data, index) => {
						let menuClass = data.classsChange;
						return (
							<li
								className={` ${state.active === data.title ? "mm-active" : ""}`}
								key={index}>
								{data?.content && !!data.content?.length ? (
									<>
										<Link
											to={"#"}
											className="has-arrow position-relative"
											onClick={() => {
												handleMenuActive(data.title);
											}}>
											{data.icon}
											<span className="nav-text">
												{Translate[lang][
													data.title.toLocaleLowerCase().replaceAll(" ", "_")
												] || data.title}
											</span>
											<i
												className="la angle la-angle-down"
												style={{
													position: "absolute",
													top: "13px",
													left: lang === "en" ? "auto" : "0",
													right: lang === "en" ? "-4px" : "auto",
													fontSize: "14px",
												}}></i>
										</Link>
										<Collapse in={state.active === data.title ? true : false}>
											<ul
												className={`${
													menuClass === "mm-collapse" ? "mm-show" : ""
												}`}>
												{data.content?.map((subData, ind) => {
													return (
														<li
															key={ind}
															className={`${
																state.activeSubmenu === subData
																	? "mm-active"
																	: ""
															}`}>
															<Link
																to={subData
																	.toLocaleLowerCase()
																	?.replaceAll(" ", "-")}
																onClick={() => setActive(subData)}
																className={`${
																	active === subData ? "active-link" : ""
																}`}>
																{Translate[lang][
																	subData
																		.toLocaleLowerCase()
																		?.replaceAll(" ", "_")
																] ||
																	subData
																		.toLocaleLowerCase()
																		?.replaceAll(" ", "_")}
															</Link>
														</li>
													);
												})}
											</ul>
										</Collapse>
									</>
								) : (
									<Link
										to={data.to}
										className="d-flex"
										onClick={() => handleMenuActive(data.title)}>
										{data.icon}
										<span className="nav-text">
											{Translate[lang][
												data.title.toLocaleLowerCase().replaceAll(" ", "_")
											] || data.title}
										</span>
									</Link>
								)}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

export default SideBar;
